(function () {
    'use strict';

    angular
        .module('oddQuestionnaireTemplatesEditRoutes', ['oddRoutes', 'questionnaireTemplatesEditModule'])
        .config(router);

    router.$inject = ['$stateProvider'];

    function router($stateProvider) {

        $stateProvider

            .state('odd.questionnaireTemplatesEdit', {
                url: '/QuestionnaireTemplate',
                views: {
                    'questionnaireTemplatesEdit@odd': {
                        controller: 'ODDQuestionnaireTemplatesListController',
                        templateUrl: require('./questionnaireTemplatesList.tpl.html')
                    }
                },
                resolve: {
                    questionnaireTemplates: ['$stateParams', 'oddQuestionnaireTemplateService', 'businessUnit', function ($stateParams, service, businessUnit) {
                        return service.getQuestionnaires(businessUnit.ODDBusinessUnitID);
                    }]
                }
            })

            .state('odd.questionnaireTemplatesEdit.addQuestionnaire', {
                url: '/Add',
                views: {
                    'questionnaireTemplatesEdit@odd': {
                        resolve: {
                            questionnaireTemplate: ['businessUnit', function (businessUnit) {
                                return { ODDBusinessUnitID: businessUnit.ODDBusinessUnitID };
                            }]
                        },
                        controller: 'ODDQuestionnaireTemplateEditController',
                        templateUrl: require('./questionnaireTemplateEdit.tpl.html')
                    }
                }
            })

            .state('odd.questionnaireTemplatesEdit.questionnaire', {
                url: '/{ODDQuestionnaireID:int}',
                resolve: {
                    questionnaireTemplate: ['$stateParams', 'oddQuestionnaireTemplateService', 'businessUnit', function ($stateParams, service, businessUnit) {
                        return service.getQuestionnaire(businessUnit.ODDBusinessUnitID, $stateParams.ODDQuestionnaireID);
                    }]
                },
                views: {
                    'questionnaireTemplatesEdit@odd': {
                        controller: 'ODDQuestionnaireTemplateEditController',
                        templateUrl: require('./questionnaireTemplateEdit.tpl.html')
                    }
                }
            })



            .state('odd.questionnaireTemplatesEdit.questionnaire.addSection', {
                url: '/Section/Add',
                resolve: {
                    questionnaireSection: ['businessUnit', 'questionnaireTemplate', function (businessUnit, questionnaireTemplate) {
                        return {
                            ODDBusinessUnitID: businessUnit.ODDBusinessUnitID,
                            ODDQuestionnaireID: questionnaireTemplate.ODDQuestionnaireID
                        };
                    }]
                },
                views: {
                    'questionnaireTemplatesEdit@odd': {
                        controller: 'ODDQuestionnaireTemplateSectionEditController',
                        templateUrl: require('./questionnaireTemplateSectionEdit.tpl.html')
                    }
                }
            })

            .state('odd.questionnaireTemplatesEdit.questionnaire.editSectionList', {
                url: '/Sections',
                views: {
                    'questionnaireTemplatesEdit@odd': {
                        controller: 'ODDQuestionnaireTemplateSectionListEditController',
                        templateUrl: require('./questionnaireTemplateSectionListEdit.tpl.html')
                    }
                }
            })

            .state('odd.questionnaireTemplatesEdit.questionnaire.section', {
                url: '/Section/{ODDSectionID:int}',
                resolve: {
                    questionnaireSection: ['$stateParams', 'businessUnit', 'oddQuestionnaireTemplateService', function ($stateParams, businessUnit, service) {
                        return service.getSection(businessUnit.ODDBusinessUnitID, $stateParams.ODDQuestionnaireID, $stateParams.ODDSectionID);
                    }]
                },
                views: {
                    'questionnaireTemplatesEdit@odd': {
                        controller: 'ODDQuestionnaireTemplateSectionEditController',
                        templateUrl: require('./questionnaireTemplateSectionEdit.tpl.html')
                    }
                }
            })

            .state('odd.questionnaireTemplatesEdit.questionnaire.section.editComponentList', {
                url: '/Components',
                views: {
                    'questionnaireTemplatesEdit@odd': {
                        controller: 'ODDQuestionnaireTemplateComponentListEditController',
                        templateUrl: require('./questionnaireTemplateComponentListEdit.tpl.html')
                    }
                }
            })

            .state('odd.questionnaireTemplatesEdit.questionnaire.section.question', {
                url: '/Question',
                abstract: true
            })

            .state('odd.questionnaireTemplatesEdit.questionnaire.section.question.edit', {
                url: '/{ODDQuestionID:int}',
                views: {
                    'questionnaireTemplatesEdit@odd': {
                        controller: 'ODDQuestionnaireTemplateQuestionEditController',
                        templateUrl: require('./questionnaireTemplateQuestionEdit.tpl.html'),
                        resolve: {
                            oddQuestionFieldTypes: ['oddQuestionnaireTemplateService', function (service) {
                                return service.getQuestionFieldTypes();
                            }],
                            oddQuestionType: ['oddQuestion', 'oddQuestionnaireTemplateService', function (oddQuestion, service) {
                                return service.getQuestionTypeByCode(oddQuestion.ODDQuestionType.Code).then(function (questionType) {
                                    oddQuestion.ODDQuestionType = questionType;
                                });
                            }],
                            oddQuestion: ['$stateParams', 'businessUnit', 'oddQuestionnaireTemplateService', function ($stateParams, businessUnit, service) {
                                return service.getQuestion(businessUnit.ODDBusinessUnitID, $stateParams.ODDQuestionnaireID, $stateParams.ODDSectionID, $stateParams.ODDQuestionID)
                            }]
                        }
                    }
                }
            })

            .state('odd.questionnaireTemplatesEdit.questionnaire.section.addQuestion', {
                url: '/Question/Add/OfType/{ODDQuestionTypeCode:string}',
                resolve: {
                    oddQuestionFieldTypes: ['oddQuestionnaireTemplateService', function (service) {
                        return service.getQuestionFieldTypes();
                    }],
                    oddQuestionType: ['$stateParams', 'oddQuestionnaireTemplateService', function ($stateParams, service) {
                        return service.getQuestionTypeByCode($stateParams.ODDQuestionTypeCode)
                    }],
                    oddQuestion: ['oddQuestionType', function (oddQuestionType) {
                        return { ODDQuestionTypeID: oddQuestionType.ODDQuestionTypeID, ODDQuestionType: oddQuestionType };
                    }],
                    campaign: function () { return {}; }
                },
                views: {
                    'questionnaireTemplatesEdit@odd': {
                        controller: 'ODDQuestionnaireTemplateQuestionEditController',
                        templateUrl: require('./questionnaireTemplateQuestionEdit.tpl.html')
                    }
                }
            })

            .state('odd.questionnaireTemplatesEdit.questionnaire.section.addQuestionTemplate', {
                url: '/Question/Add/OfType/{ODDQuestionTypeCode:string}/{ODDQuestionChoiceTemplateID:int}',
                resolve: {
                    oddQuestionFieldTypes: ['oddQuestionnaireTemplateService', function (service) {
                        return service.getQuestionFieldTypes();
                    }],
                    oddQuestionChoiceTemplate: ['$stateParams', 'oddQuestionnaireTemplateService', function ($stateParams, service) {
                        return service.getQuestionMultiChoiceTemplate($stateParams.ODDQuestionChoiceTemplateID)
                    }],
                    oddQuestionType: ['$stateParams', 'oddQuestionnaireTemplateService', function ($stateParams, service) {
                        return service.getQuestionTypeByCode($stateParams.ODDQuestionTypeCode)
                    }],
                    oddQuestion: ['oddQuestionType', 'oddQuestionChoiceTemplate', function (oddQuestionType, oddQuestionChoiceTemplate) {
                        return {
                            ODDQuestionTypeID: oddQuestionType.ODDQuestionTypeID,
                            ODDQuestionType: oddQuestionType,
                            ODDQuestionChoiceTemplate: oddQuestionChoiceTemplate,
                            ODDQuestionChoiceTemplateID: oddQuestionChoiceTemplate.ODDQuestionChoiceTemplateID
                        };
                    }],
                    campaign: function () { return {}; }
                },
                views: {
                    'questionnaireTemplatesEdit@odd': {
                        controller: 'ODDQuestionnaireTemplateQuestionEditController',
                        templateUrl: require('./questionnaireTemplateQuestionEdit.tpl.html')
                    }
                }
            })

        .state('odd.questionnaireTemplatesEdit.questionnaire.section.staticTextEdit', {
            url: '/{ODDStaticTextID:int}',
            resolve: {
                oddStaticText: ['$stateParams', 'businessUnit', 'questionnaireSection', 'oddQuestionnaireTemplateService', function ($stateParams, businessUnit, questionnaireSection,service) {
                    return service.getStaticText(businessUnit.ODDBusinessUnitID, questionnaireSection.ODDQuestionnaireID, questionnaireSection.ODDSectionID, $stateParams.ODDStaticTextID);
                }],
            },
            views: {
                'questionnaireTemplatesEdit@odd': {
                    controller: 'ODDQuestionnaireTemplateStaticTextEditController',
                    templateUrl: require('./questionnaireTemplateStaticTextEdit.tpl.html'),
                }
            }
        })

         .state('odd.questionnaireTemplatesEdit.questionnaire.section.addStaticText', {
             url: '/StaticText/Add',
             resolve: {
                 oddStaticText: function () { return {}; }
             },
             views: {
                 'questionnaireTemplatesEdit@odd': {
                     controller: 'ODDQuestionnaireTemplateStaticTextEditController',
                     templateUrl: require('./questionnaireTemplateStaticTextEdit.tpl.html')
                 }
             }
         });




    }
})();